import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import SignIn from "../src/Pages/SignIn/SignIn";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Accounts from "./Pages/Accounts/Accounts";
import Overview from "./Pages/Accounts/Overview";
import TradeDetail from "./Pages/Accounts/TradeDetail";
import Trades from "./Pages/Trades/Trades";
import Transactions from "./Pages/Transactions/Transactions";
import Challenges from "./Pages/Challenges/Challenges";
import ChallengeInfo from "./Pages/Challenges/ChallengeInfo";
import Customers from "./Pages/Customers/Customers";
import CustomerInfo from "./Pages/Customers/CustomerInfo";
import KYC from "./Pages/KYC/KYC";
import Coupons from "./Pages/Coupons/Coupons";
import CouponInfo from "./Pages/Coupons/CouponInfo";
import Announcements from "./Pages/Announcements/Announcements";
import Support from "./Pages/Support/Support";
import Rules from "./Pages/Rules/Rules";
import RuleInfo from "./Pages/Rules/RuleInfo";
import Blogs from "./Pages/Blogs/Blogs";
import Profile from "./Pages/Profile/Profile";
import Admins from "./Pages/Admins/Admins";
import AdminInfo from "./Pages/Admins/AdminInfo";
import Logs from "./Pages/Logs/Logs";
import SalesParticipation from "./Pages/SalesParticipation/SalesParticipation";
import Dollar from "./Pages/Dollar/Dollar";
import AppShell from "./Components/AppShell";

function App() {
  const isAuthenticated = () => {
    return Boolean(
      localStorage.getItem("access") || localStorage.getItem("refresh"),
    );
  };

  const RequireAuth = () =>
    isAuthenticated() ? <Outlet /> : <Navigate to="/signin" replace />;

  const RootRoute = () => (
    <Navigate to={isAuthenticated() ? "/dashboard" : "/signin"} replace />
  );

  const SignInRoute = () =>
    isAuthenticated() ? <Navigate to="/dashboard" replace /> : <SignIn />;

  return (
    <Routes>
      <Route path="/" element={<RootRoute />} />
      <Route path="/signin" element={<SignInRoute />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/trades" element={<Trades />} />
          <Route path="/account/:accountId/overview" element={<Overview />} />
          <Route
            path="/account/:accountId/trade-detail"
            element={<TradeDetail />}
          />
          <Route
            path="/transactions"
            element={<Navigate to="/transactions/payments" replace />}
          />
          <Route
            path="/transactions/:transactionTab"
            element={<Transactions />}
          />
          <Route path="/sales-participation" element={<SalesParticipation />} />
          <Route path="/challenges" element={<Challenges />} />
          <Route
            path="/challenges/:challengeId/challenge-info"
            element={<ChallengeInfo />}
          />
          <Route path="/dollar" element={<Dollar />} />
          <Route path="/customers" element={<Customers />} />
          <Route
            path="/customers/:customerId/customer-info"
            element={<CustomerInfo />}
          />
          <Route path="/kyc" element={<KYC />} />
          <Route path="/support" element={<Support />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route
            path="/coupons/:couponId/coupon-info"
            element={<CouponInfo />}
          />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/rules/rule-info" element={<RuleInfo />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/admins/admin-info" element={<AdminInfo />} />
          <Route path="/logs" element={<Logs />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
